import api from "../../../Component/axios";

export const useOrdenEmpaque = () => {
  const token = localStorage.getItem("@Token");
  const getOrdenEmpaque = async (fecha, campo, variedad) => {
    try {
      const response = await api.get(
        `api/pedido-empaque/orden_empaque/?fecha=${fecha}&campo=${campo}&variedad=${variedad}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  return { getOrdenEmpaque };
};
